import AutosaveTextarea from 'components/styledInput/AutosaveTextarea';
import useText from 'hooks/useText';

// The description of the task, written in place, or only read by whoever may
// not edit the task.
const TaskDescriptionField = ({ initial, onSave, canEdit = true }) => {
  const { text } = useText('taskPanel');
  return (
    <AutosaveTextarea
      label={text('descriptionLabel')}
      placeholder={text('descriptionPlaceholder')}
      initial={initial}
      onSave={onSave}
      isDisabled={!canEdit}
    />
  );
};

export default TaskDescriptionField;
